export const ECOMMERCE_ROUTING = [
    {
        path: '/ecommerce',
        name: 'ecommerce',
        meta: {
            auth: true,
            breadcrumb: [
                { name: 'Kiện TMĐT', pathName: 'ecommerce', icon: 'fa fa-shopping-cart' },
            ]
        },
        component: () => import('./Ecommerce.vue'),
        redirect: { name: 'ecommerce-index' },
        children: [
            {
                path: '/kien-tmdt.html',
                name: 'ecommerce-index',
                component: () => import('./list/List.vue'),
            },
            {
                path: '/khieu-nai-kien-tmdt/:orderId/:orderType',
                name: 'ecommerce-complain',
                meta: {
                    breadcrumb: [
                        { name: 'Khiếu nại kiện TMĐT', pathName: 'ecommerce-complain', icon: 'fa fa-bar-chart' },
                ] },
                component: () => import('../order/components/complain-order/ComplainOrder.vue'),
            },
            {
                path: '/khieu-nai-kien-tmdt/:orderId/:complainId/:orderType',
                name: 'detail-ecommerce-complain',
                meta: {
                    breadcrumb: [
                        { name: 'Khiếu nại kiện TMĐT', pathName: 'detail-ecommerce-complain', icon: 'fa fa-bar-chart' },
                    ]
                },
                component: () => import('../order/components/complain-order/ComplainOrder.vue')
            }
        ]
    }
];